import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { CSSTransitionGroup } from 'react-transition-group';
import { toastr } from "react-redux-toastr";
import Joyride from "react-joyride";
import PaginationAdvanced from "../components/PaginationAdvanced";
import Search from "./Search";
import { StarterCampaignPreview } from "./StarterCampaignPreview";
import _ from "lodash";
import { FormControl, Modal } from "react-bootstrap";

import Index from "./Index";
import { fetchActiveStarterCampaigns, duplicateCampaignFromStarter } from "../actions/index";
import StarterCampaignsIndexTourSteps from "./tours/StarterCampaignsIndexTourSteps";

export class StarterCampaignsIndex extends Index {
  static propTypes = {
    match: PropTypes.object.isRequired,
    fetchActiveStarterCampaigns: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    campaigns: PropTypes.object,
    duplicateCampaignFromStarter: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
  }

  fetchData() {
    let newQueries = {
        page: this.state.page || 1,
        per_page: this.state.per_page || "",
        search: this.state.search || "",
        category: this.state.category || "",
        sort: this.state.sort || "",
        direction: this.state.direction || ""
      };
    this.props.fetchActiveStarterCampaigns(
      this.serialize(newQueries)
    );
    this.props.history.push(`/starter_campaigns${this.serialize(newQueries)}`);
  }

  categoryOptions() {
    if (
      !this.props.campaigns.meta ||
      this.props.campaigns.meta.categories === undefined
    ) {
      return "";
    }
    let categories = this.props.campaigns.meta.categories;
    return super.categoryOptions(categories);
  }

  onDuplicateClick(e) {
    this.props
      .duplicateCampaignFromStarter(
        e.target.dataset.campaignId,
        this.props
      )
      .then(campaign => {
        if (campaign.payload !== undefined) {
          toastr.success("Workflow draft created!");
          this.props.history.push(`/campaigns/${campaign.payload.data.data.id}?from_starter_workflow=true)}`);
        }
      });
  }

  openPreviewActionModal(campaignId) {
    this.setState({ showPreviewActionModal: campaignId });
  }

  openPreviewAction(campaignId, e) {
    e.preventDefault();
    this.openPreviewActionModal(campaignId);
  }

  closePreviewActionModal() {
    this.setState({ showPreviewActionModal: false });
  }

  showPreviewActionModal(campaignId) {
    if (this.state.showPreviewActionModal == campaignId) {
      return true;
    } else {
      return false;
    }
  }

  showAuthor(campaign) {
    if (campaign.author) {
      return <p>Author: {campaign.author}</p>;
    }
  }

  renderCampaigns() {
    if (!this.props.campaigns.data) {
      return (
        <tr>
          <td colSpan={14}>
            <div className="vertical-center">
              <CSSTransitionGroup
                transitionName="spinner"
                transitionAppear={true}
                transitionAppearTimeout={500}
              />
            </div>
          </td>
        </tr>
      );
    } else if (this.props.campaigns.data.length == 0) {
      return (
        <tr>
          <td colSpan={14}>
            <div className="well well-lg text-center">
              No workflows found in the Library.
            </div>
          </td>
        </tr>
      );
    }

    return this.props.campaigns.data.map(campaign => {
      if (campaign.medium_counts) {
        return (
          <tr key={campaign.id}>
            <td>
              <a
                onClick={this.openPreviewAction.bind(this, campaign.id)}
                style={{ cursor: "pointer" }}
              >
                <strong>{campaign.name}</strong>
              </a>
            </td>
            <td className="">{campaign.category}</td>
            <td className="">{campaign.author}</td>
            <td className="">
              {_.truncate(campaign.description, { length: 40 })}
            </td>
            <td className="text-right">
              {campaign.medium_counts["email"] || 0}
            </td>
            <td className="text-right">{campaign.medium_counts["sms"] || 0}</td>
            <td className="text-right">
              {campaign.medium_counts["manual"] || 0}
            </td>
            <td className="text-right">
              <button
                className="btn btn-sm btn-default m-r-10 template_btn_use"
                data-campaign-id={campaign.id}
                onClick={this.onDuplicateClick.bind(this)}
              >
                Use
              </button>
            </td>
            <td className="text-right">
              <button
                className="btn btn-sm btn-default template_btn_more_info"
                data-campaign-id={campaign.id}
                onClick={this.openPreviewAction.bind(this, campaign.id)}
              >
                Preview
              </button>
              <Modal
                show={this.showPreviewActionModal(campaign.id)}
                onHide={this.closePreviewActionModal.bind(this)}
                backdrop="static"
                keyboard={false}
                autoFocus={true}
                enforceFocus={false}
              >
                <Modal.Header closeButton={true}>
                  <Modal.Title id="contained-modal-title-lg">
                    {campaign.name}
                  </Modal.Title>
                  <div className="m-t-10">{this.showAuthor(campaign)}</div>
                  <div>{campaign.description}</div>
                </Modal.Header>
                <Modal.Body className="starter_workflow_preview">
                  <StarterCampaignPreview
                    campaign={campaign}
                    match={this.props.match}
                    templates={campaign.email_templates}
                    smsTemplates={campaign.sms_templates}
                  />
                </Modal.Body>
              </Modal>
            </td>
          </tr>
        );
      }
    });
  }

  startTour() {
    this.setState({
      steps: StarterCampaignsIndexTourSteps.tourSteps(),
      startTour: true
    });
  }

  render() {
    let count = 0;
    if (this.props.campaigns.meta) {
      count = this.props.campaigns.meta.count;
    }
    return (
      <div className="campaigns_index">
        <Joyride
          run={this.state.startTour}
          continuous={true}
          steps={this.state.steps}
          showSkipButton={true}
          showProgress={true}
          scrollToSteps={false}
          callback={this.tourCallback.bind(this)}
        />
        <div className="row">
          <h1>
            Library
            <button
              bsStyle="default"
              className="btn btn-sm btn-primary help_icon_smaller"
              onClick={this.startTour.bind(this)}
            >
              ?
            </button>
            <div className="pull-right">
              <Search
                handleSearch={this.handleSearch.bind(this)}
                searchStr={this.state.search}
              />
            </div>
            <div className="pull-right col-sm-3">
              <FormControl
                componentClass="select"
                type="select"
                className="input"
                wrapperClassName="p-0"
                addonBefore={"Filter by Category"}
                name="category_id"
                onChange={this.handleFilterCategory.bind(this)}
              >
                <option value="">All Categories</option>
                {this.categoryOptions()}
              </FormControl>
            </div>
          </h1>
          <div className="alert alert-warning text-center alert-important-text">
            <strong>VERY IMPORTANT:</strong> Please review every email and/or
            text to make sure it pertains to you and your area before you
            publish. Fields marked with parenthesis around them need to be
            changed manually.
          </div>
        </div>
        <div className="row">
          <table className="table table-striped">
            <thead>
              <tr>
                <th
                  className={`campaign_name ${this.indicateSorting("name")}`}
                  data-sort="name"
                  onClick={this.handleOrder.bind(this)}
                >
                  Name
                </th>
                <th
                  className={`campaign_category ${this.indicateSorting(
                    "category"
                  )}`}
                  data-sort="category"
                  onClick={this.handleOrder.bind(this)}
                >
                  Category
                </th>
                <th
                  className={`campaign_author ${this.indicateSorting(
                    "author"
                  )}`}
                  data-sort="author"
                  onClick={this.handleOrder.bind(this)}
                >
                  Author
                </th>
                <th className="category_description">Description</th>
                <th className="campaign_step_email text-right">Email</th>
                <th className="campaign_step_sms text-right">SMS</th>
                <th className="campaign_step_task text-right">Follow-up</th>
                <th className="" />
                <th className="" />
              </tr>
            </thead>
            <tbody>{this.renderCampaigns()}</tbody>
          </table>
        </div>
        <div className="row text-right">
          <PaginationAdvanced
            handle={this.handlePagination.bind(this)}
            total={count}
            page={this.state.page}
            per_page={this.state.per_page}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    campaigns: state.campaigns.all
  };
}

export default connect(
  mapStateToProps,
  { fetchActiveStarterCampaigns, duplicateCampaignFromStarter }
)(StarterCampaignsIndex);
